import { useState, useEffect } from 'react';

export function useMobileColumns() {
  const [mobileColumns, setMobileColumns] = useState<1 | 2>(() => {
    // Load preference from localStorage, default to 2 columns
    const saved = localStorage.getItem('mobileColumnView');
    return saved === '1' ? 1 : 2;
  });

  useEffect(() => {
    // Listen for column view changes from the navigation header
    const handleColumnChange = (event: CustomEvent) => {
      setMobileColumns(event.detail as 1 | 2);
    };

    window.addEventListener('mobileColumnViewChange' as any, handleColumnChange);
    
    return () => {
      window.removeEventListener('mobileColumnViewChange' as any, handleColumnChange);
    };
  }, []);

  return mobileColumns;
}